import React, { Fragment } from "react";
import MyDefaultCoverPhoto from "site_media/images/DefaultCoverYosemite.png";

class ProjectBanner extends React.Component {
  render() {
    return (
      <Fragment>
        {/* <Image
          src={this.props.image}
        /> */}
        <div className="banner-img-back" style={{
          backgroundImage: `url(${this.props.image || MyDefaultCoverPhoto
            })`,
        }}></div></Fragment>
    );
  }
}

export default ProjectBanner;
